/* eslint-disable max-len */
import React from 'react';

const TrashCanIcon = (props) => (
  <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M13.3857 1.66513H9.99076V0.921478C9.99076 0.404157 9.50577 0 8.90762 0H5.07621C4.47806 0 3.99307 0.404157 3.99307 0.921478V1.66513H0.598152C0.25866 1.66513 0 1.92379 0 2.26328C0 2.60277 0.25866 2.86143 0.598152 2.86143H1.3418L2.08545 12.1732C2.10162 13.2725 2.99076 14.1455 4.09007 14.1455H9.90993C11.0092 14.1455 11.8822 13.2725 11.9145 12.1732L12.6582 2.8776H13.4018C13.7413 2.8776 14 2.61894 14 2.27945C14 1.93995 13.7252 1.66513 13.3857 1.66513ZM5.20554 1.21247H8.79446V1.66513H5.20554V1.21247ZM10.7182 12.0924V12.1247C10.7182 12.5612 10.3626 12.9169 9.9261 12.9169H4.09007C3.65358 12.9169 3.29792 12.5612 3.29792 12.1247L2.55427 2.86143H11.4619L10.7182 12.0924Z'
      fill='#969EA5'
    />
    <path
      d='M5.41567 10.9284H5.43183C5.77133 10.9122 6.01382 10.6212 6.01382 10.3141L5.78749 5.43184C5.77133 5.10851 5.51266 4.84985 5.18934 4.84985H5.17317C4.83368 4.86602 4.59119 5.15701 4.59119 5.46417L4.81751 10.3464C4.81751 10.702 5.10851 10.9284 5.41567 10.9284Z'
      fill='#969EA5'
    />
    <path
      d='M8.55203 10.9284H8.56819C8.89152 10.9284 9.15018 10.6697 9.16635 10.3464L9.39267 5.46417C9.40884 5.12468 9.15018 4.84985 8.81069 4.84985H8.79452C8.47119 4.84985 8.21253 5.10851 8.19637 5.43184L7.98621 10.3141C7.98621 10.6374 8.21253 10.9122 8.55203 10.9284Z'
      fill='#969EA5'
    />
  </svg>
);

export default TrashCanIcon;
